import { ModelBase } from 'store/model-base';

export class SaveTmoAddress extends ModelBase {
    public static storeName: string = 'saveTmoAddress';

    public requestId: string;
    public streetAddress: string;
    public streetAddress2: string;
    public city: string;
    public state: string;
    public zip: string;

    public get isValid(): boolean {
        return Boolean(this.streetAddress && this.streetAddress.trim());
    }

    public get formatted(): string {
        return `${this.streetAddress} ${this.city}, ${this.state} ${this.zip}`;
    }

    public get cityStateZip(): string {
        return `${this.city}, ${this.state} ${this.zip}`;
    }
}
